/**
 * 配置管理模块
 * 根据环境变量REACT_APP_ENV加载对应环境的配置
 */
import devConfig from './env/config.dev';
import prodConfig from './env/config.prod';

// 获取当前环境
const env = process.env.REACT_APP_ENV || 'dev';

// 根据环境选择配置
let config;
switch(env) {
  case 'production':
  case 'prod':
    config = prodConfig;
    break;
  case 'development':
  case 'dev':
  default:
    config = devConfig;
    break;
}

// 导出配置
export const {
  BASE_PATH,
  API_BASE_URL,
  API_BASE_URL2,
  VERSION,
  DEFAULT_WELCOME_MESSAGE,
  MODEL_ICONS,
  FILE_UPLOAD,
  UI_SETTINGS
} = config;

// 导出完整配置对象
export default config; 